import { stripTrailingSlash } from '@utils/url';

export const LOCALE_PREFIX_PATTERN = /^\/[a-z]{2}(?:-[a-z]{2})?(?:\/|$)/i;
export const ABSOLUTE_LINK_PATTERN = /^(?:[a-z][a-z\d+\-.]*:|\/\/|#)/i;
export const LOCALE_ONLY_PATH_PATTERN = /^\/[a-z]{2}(?:-[a-z]{2})?\/?$/i;

/**
 * Normalises a breadcrumb href to a locale-prefixed, trailing-slash-free path.
 * Absolute links, protocol-relative links, hashes and hrefs that already carry a
 * locale prefix are passed through untouched (minus any trailing slash).
 *
 * Shared by `_components/Breadcrumbs` (link hrefs) and
 * `_components/Breadcrumbs/BreadcrumbsJsonLd` (structured-data URLs) so both
 * resolve the exact same path for a given item.
 */
export const withLocalePrefix = (href: string, locale?: string) => {
  if (ABSOLUTE_LINK_PATTERN.test(href) || LOCALE_PREFIX_PATTERN.test(href)) {
    return stripTrailingSlash(href);
  }

  const resolvedLocale = locale ?? 'en';
  const normalizedHref = href.startsWith('/') ? href : `/${href}`;

  if (normalizedHref === '/') {
    return `/${resolvedLocale}`;
  }

  return stripTrailingSlash(`/${resolvedLocale}${normalizedHref}`);
};
